<script>
import BaseHeader from '@/components/BaseHeader.vue';
import { Filters } from '@/modules/analise-desmatamento/views/components';
import ReportAnalyzeList from '@/modules/analise-desmatamento/views/components/report-analyze-list/index.vue';

export default {
    components: {
        BaseHeader,
        Filters,
        ReportAnalyzeList
    }
};
</script>

<template>
    <div id="cars-list-page">
        <base-header :titulo="$tc('analyze-deforestation.words.title')" />
        <div class="view-container">
            <filters />
            <div style="margin-top: 40px" />
            <report-analyze-list />
        </div>
    </div>
</template>

<style scoped lang="scss">
#cars-list-page {
    #header-actions {
        display: flex;
        align-items: flex-end;
        padding: 10px 0;
        .el-button {
            width: 130px;
        }
        @media (max-width: 768px) {
            flex-direction: column;
            gap: 10px;
        }
    }
    .view-container {
        max-width: 1244px;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        padding: 20px;

        h3 {
            color: var(--primary);
            font-size: 16px;
            font-weight: 600;
            margin: 8px 0;
        }
    }
}
</style>
